import { createFileRoute } from '@tanstack/react-router';
import { TextSendStatusPage } from '@/components/work-orders';

// A Text send's status link, emailed after payment. Open to whoever holds it, signed in or not.
export const Route = createFileRoute('/text-status/$token')({
  component: TextSendStatusRoute,
});

function TextSendStatusRoute() {
  const { token } = Route.useParams();
  return <TextSendStatusPage token={token} />;
}
